import {useUiVersion} from "../../context/UserModulesContext";


// Título de la ficha del cliente. En v1 es el ÚNICO lugar donde se ve de quién es la pantalla, así
// que se renderiza igual que siempre.
//
// En v2 no va: el breadcrumb del topbar ya dice el nombre del cliente y además es el selector para
// cambiar de cliente, o sea que es el ancla real. Repetirlo acá en un h1 de 40px duplica la
// información y gasta los ~86px del `.section-header` (min-height 5.4em) empujando el contenido
// fuera del fold. Las 19 pantallas que montan este componente no se tocan: la decisión vive acá.
export function ClientHeader({name}) {
    const {isV2} = useUiVersion();

    if (isV2) return null;

    return (
        <header className="section-header">
            <h1 className="section-title">{name}</h1>
        </header>
    );
}
